import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { BASE_APP_ROUTE } from "./constants";
import { SnackbarProvider } from "notistack";
import { Notifier } from "./app/widgets";

import App from "./App";
import { configureStore } from "./store";

/* styles */
import { ThemeProvider } from "@material-ui/core";
import theme from "./assets/styles/theme";
import "react-quill/dist/quill.snow.css";
import "./assets/styles/globals.scss";

const store = configureStore();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={BASE_APP_ROUTE}>
        <ThemeProvider theme={theme}>
          <SnackbarProvider
            maxSnack={4}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <Notifier />
            <App />
          </SnackbarProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
